import { render, staticRenderFns } from "./sjshow.vue?vue&type=template&id=30a5928a&scoped=true&"
import script from "./sjshow.vue?vue&type=script&lang=js&"
export * from "./sjshow.vue?vue&type=script&lang=js&"
import style0 from "./sjshow.vue?vue&type=style&index=0&id=30a5928a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5928a",
  null
  
)

export default component.exports